import { render } from "./TheButtomNav.vue?vue&type=template&id=22914d48&scoped=true"
import script from "./TheButtomNav.vue?vue&type=script&lang=ts"
export * from "./TheButtomNav.vue?vue&type=script&lang=ts"

import "./TheButtomNav.vue?vue&type=style&index=0&id=22914d48&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-22914d48"

export default script